import React, { useState, useEffect } from "react";
import { Alert, Container, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import CustomNavbar from "../../../components/CustomNavbar";
import SidebarDashboard from "../../../components/SidebarDashboard";
import { getFuncStructure } from "../../../redux/funcionalstructure/actions";
import OrgChart from "../../../components/OrgChart";
import { withRouter } from "react-router-dom";
const FuncOrganizationalStructure = (props) => {
  //Redux
  const dispatch = useDispatch();
  const structure = useSelector((store) => store.funcStructure.astructures);
  const data = useSelector((store) => store.funcStructure.structures);
  const loading = useSelector((store) => store.funcStructure.loading);
  // const nodeToAppend = useSelector(store => store.structure.nodeToAppend);
  // const loadingAppendNodes = useSelector(store => store.structure.loadingAppendNodes);
  //Métodos
  useEffect(() => {
    dispatch(
      getFuncStructure(
        props.match.params.org,
        parseInt(props.match.params.type)
      )
    );
  }, [dispatch, props.match.params.org, props.match.params.type]);

  const [show, setShow] = useState(false);
  const onShowSidebar = () => setShow(show ? false : true);
  const onNodeClick = (nodeId) => {
    const parentNode = data.find(
      (item) => parseInt(item.id) === parseInt(nodeId)
    );
    if (parentNode) {
      props.history.push(
        `/estructura-unidad/${nodeId}/${parentNode.nombre}/${props.match.params.type}`
      );
    }
  };
  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid style={{ overflow: "hidden" }}>
          {/* <h5 className="font-weight-bold text-uppercase">
            {props.match.params.name}
          </h5>
          <hr /> */}
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : data.length > 0 ? (
            <OrgChart
              data={structure}
              onNodeClick={onNodeClick}
              name={props.match.params.name}
            />
          ) : (
            <Alert className="my-4" variant="info">
              Sin estructuras que mostrar
            </Alert>
          )}
        </Container>
      </div>
    </>
  );
};

export default withRouter(FuncOrganizationalStructure);
